import {FAILURE_POSTFIX, REQUEST_POSTFIX, SERVER_API_PREFIX} from 'new-constants/api.constants';
import {VIPPS_ERROR} from 'new-constants/payment.constants';
import {ADD_MENU_ENTRY_TO_CART} from 'new-constants/order-line.constants';
import {FetchErrorState} from './fetch-error.reducer.types';

const initialState: FetchErrorState = {};

export const fetchErrorReducer = (previousState = initialState, action): FetchErrorState => {
	if (action.type === VIPPS_ERROR) {
		return {
			...previousState,
			[VIPPS_ERROR]: action.message,
		};
	}

	if (action.type === ADD_MENU_ENTRY_TO_CART && action.modifierValidationErrors.length > 0) {
		return {
			...previousState,
			[ADD_MENU_ENTRY_TO_CART]: action.modifierValidationErrors,
		};
	}

	const dismissError = action.dismissError || action.payload?.dismissError;
	if (dismissError) {
		previousState = {
			...previousState,
			[dismissError]: null,
		};
	}

	if (!action.type.startsWith(SERVER_API_PREFIX)) {
		return previousState;
	}

	if (action.type.endsWith(REQUEST_POSTFIX)) {
		const fetchConstant = action.type.replace(REQUEST_POSTFIX, '');

		return {
			...previousState,
			[fetchConstant]: null,
		};
	}

	if (action.type.endsWith(FAILURE_POSTFIX)) {
		const fetchConstant = action.type.replace(FAILURE_POSTFIX, '');

		return {
			...previousState,
			[fetchConstant]: action.payload.statusText,
		};
	}

	return previousState;
};
